// extracted by mini-css-extract-plugin
export default {"unavailable":"News-unavailable__cadc7bc8fa84d72e49ce"};